import { render, staticRenderFns } from "./organization_member_delete_form.vue?vue&type=template&id=3a827b2c&scoped=true&"
import script from "./organization_member_delete_form.vue?vue&type=script&lang=js&"
export * from "./organization_member_delete_form.vue?vue&type=script&lang=js&"
import style0 from "./organization_member_delete_form.vue?vue&type=style&index=0&id=3a827b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a827b2c",
  null
  
)

export default component.exports